import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["startTime", "endTime"],
  _excluded2 = ["startTime", "endTime"];
import TimeOfDay from 'automation-ui-flow-core/fields/time/TimeOfDay';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class TimeRangeMetadata extends createImmutableObjectClass({
  day: 'MONDAY',
  startTime: null,
  endTime: null
}, {
  fromJSON: _ref => {
    let {
        startTime,
        endTime
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      startTime: new TimeOfDay(startTime || {
        hour: 0,
        minute: 0
      }),
      endTime: new TimeOfDay(endTime || {
        hour: 23,
        minute: 59
      })
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        startTime,
        endTime
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      startTime: startTime.toJSON(),
      endTime: endTime.toJSON()
    }, rest);
  }
}) {
  updateDay(day) {
    return this.set('day', day);
  }
  updateStartTime(minutes) {
    return this.update('startTime', startTime => startTime.updateTime(minutes));
  }
  updateEndTime(minutes) {
    return this.update('endTime', endTime => endTime.updateTime(minutes));
  }
  getStartTimeInMinutes() {
    return this.startTime.getMinutes();
  }
  getEndTimeInMinutes() {
    return this.endTime.getMinutes();
  }
  getDay() {
    return this.day;
  }
}